export const patientColumns = [
  {
    label: 'First name',
    variations: ['name first', 'f name', 'name f', 'given name', 'name given'],
    value: 'f_name',
    missingMessage: {
      className: 'warning',
      message: `First name is highly recommended`
    }
  },
  {
    label: 'Last name',
    variations: ['name last', 'l name', 'name l', 'family name', 'name family'],
    value: 'l_name',
    missingMessage: {
      className: 'warning',
      message: `Last name is highly recommended`
    }
  },
  { label: 'Name', value: 'name' },
  { label: 'Middle name', variations: ['name middle', 'm name', 'name m'], value: 'm_name' },
  {
    label: 'Email primary',
    variations: ['email', 'email address', 'primary email', 'home email'],
    value: 'email',
    missingMessage: {
      className: 'error',
      message: `Email is required for patient import`
    }
  },
  {
    label: 'Email 2',
    variations: [
      'secondary email',
      'secondary email address',
      'second email address',
      'email address secondary',
      'email address second',
      'second email',
      'work email'
    ],
    value: 'email_2'
  },
  {
    label: 'Email 3',
    variations: ['third email', 'third email address', 'email address third'],
    value: 'email_3'
  },
  {
    label: 'Phone primary',
    variations: ['phone', 'phone number', 'primary phone', 'cell'],
    value: 'phone',
    missingMessage: {
      className: 'warning',
      message: `Phone number is highly recommended`
    }
  },
  { label: 'Phone 2', variations: ['secondary phone', 'work phone'], value: 'phone_2' },
  { label: 'Phone 3', value: 'phone_3' },
  { label: 'Address line 1', variations: ['street address', 'street'], value: 'address_ln_1' },
  {
    label: 'Address line 2',
    variations: ['suite', 'apartment', 'aprtmnt'],
    value: 'address_ln_2'
  },
  { label: 'City', value: 'city' },
  { label: 'State', value: 'state' },
  { label: 'Zip', variations: ['postal code'], value: 'zip' },
  {
    label: 'Full street address',
    variations: ['full address', 'street address'],
    value: 'full_street_address'
  },
  {
    label: 'Address line 1 (second)',
    variations: ['secondary address line 1', 'secondary street address'],
    value: 'address_ln_1_2'
  },
  {
    label: 'Address line 2 (second)',
    variations: ['secondary address line 2', 'secondary aptartment', 'secondary suite'],
    value: 'address_ln_2_2'
  },
  { label: 'City (second)', variations: ['secondary city'], value: 'city_2' },
  { label: 'State (second)', variations: ['secondary state'], value: 'state_2' },
  { label: 'Zip (second)', variations: ['secondary zip'], value: 'zip_2' },
  { label: 'Date of birth', variations: ['dob', 'birthday'], value: 'dob' },
  { label: 'SSN', variations: ['social security number'], value: 'ssn' },
  { label: 'Gender', variations: ['sex'], value: 'gender' },
  { label: 'Race', variations: [], value: 'race' },
  { label: 'Marital status', variations: [], value: 'marital_status' },
  {
    label: 'Custom ID',
    variations: ['custom id', 'customer id', 'square customer id', 'square id'],
    value: 'custom_id'
  }
];
